<template>
  <BaseDrawer
    :visible="visible"
    :show_footer="false"
    :title="drawer_title"
    drawer_width="lg:!w-[64rem]"
    padding_x="px-0"
    dismissable
    @update:visible="onVisibleChange"
  >
    <div
      v-if="profile_component && profile_record"
      data-test="profile-drawer"
    >
      <component
        :is="profile_component"
        :customer="profile_record"
        :lead="profile_record"
        :partner="profile_record"
        :projects="projects"
        class="px-5"
        @deleted="handleDeleted"
      />
    </div>
  </BaseDrawer>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import BaseDrawer from '@/app/shared_components/drawer/BaseDrawer.vue';
import TheCustomerProfile from '@/app/_employees/components/contacts/TheCustomerProfile.vue';
import TheLeadProfile from '@/app/_employees/components/contacts/TheLeadProfile.vue';
import ThePartnerProfile from '@/app/_employees/components/contacts/ThePartnerProfile.vue';
import { PROFILE_TYPES } from '@/app/data/model_constants';
import useProfileDrawer from '@/composables/useProfileDrawer.js';

const store = useStore();
const { visible, profile_type, profile_record, closeProfile, handleDeleted } = useProfileDrawer();

const projects = computed(() => store.getters.projects);

const profile_component = computed(() => {
  if (profile_type.value === PROFILE_TYPES.CUSTOMER) return TheCustomerProfile;
  if (profile_type.value === PROFILE_TYPES.LEAD) return TheLeadProfile;
  if (profile_type.value === PROFILE_TYPES.PARTNER) return ThePartnerProfile;
  return null;
});

const drawer_title = computed(() => _.get(profile_record.value, 'attributes.name', ''));

function onVisibleChange(new_visible) {
  if (!new_visible) closeProfile();
}
</script>
